<template>
    <div>
        <h3 class="my-3 text-lg font-medium leading-6 text-gray-400">
            Transferências
        </h3>
        <filters
            v-model="filters"
            :loading="loading"
            @fetch="
                transfers = [];
                fetch(true);
            "
            search-filter
            id-filter
            id-filter-placeholder="Id da transferência"
            search-label="Filtre por nome ou e-mail do usuário"
        />

        <div class="mt-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div class="inline-block min-w-full sm:px-6 lg:px-8">
                <div
                    class="not-prose relative overflow-hidden overflow-hidden rounded-xl bg-slate-50 dark:bg-slate-800/25"
                >
                    <table class="w-full table-auto border-collapse text-sm">
                        <thead>
                            <tr class="text-white">
                                <th
                                    class="px-6 py-4 text-left text-sm font-medium"
                                >
                                    #
                                </th>
                                <th
                                    class="px-6 py-4 text-left text-sm font-medium"
                                >
                                    Usuário
                                </th>
                                <th
                                    class="px-6 py-4 text-left text-sm font-medium"
                                >
                                    Cashout
                                </th>
                                <th
                                    class="px-6 py-4 text-left text-sm font-medium"
                                >
                                    Provider
                                </th>
                                <th
                                    class="px-6 py-4 text-left text-sm font-medium"
                                >
                                    Status
                                </th>
                                <th
                                    class="px-6 py-4 text-left text-sm font-medium"
                                >
                                    Criado em
                                </th>
                                <th
                                    class="px-6 py-4 text-left text-sm font-medium"
                                >
                                    Ações
                                </th>
                            </tr>
                        </thead>
                        <tbody class="bg-white dark:bg-slate-800">
                            <tr v-for="t in transfers" :key="t.id">
                                <td
                                    class="border-b border-slate-100 p-4 pl-8 text-slate-500 dark:border-slate-700 dark:text-slate-200"
                                >
                                    {{ t.id }}
                                </td>
                                <td
                                    class="border-b border-slate-100 p-4 pl-8 text-slate-500 dark:border-slate-700 dark:text-slate-200"
                                >
                                    <button
                                        class="text-indigo-500 hover:underline"
                                        @click.prevent="manageUser(t.user)"
                                    >
                                        {{ t.user?.name }} {{ t.user?.email }}
                                    </button>
                                </td>
                                <td
                                    class="border-b border-slate-100 p-4 pl-8 text-slate-500 dark:border-slate-700 dark:text-slate-200"
                                >
                                    {{ t.cashout_id }}
                                </td>
                                <td
                                    class="border-b border-slate-100 p-4 pl-8 text-slate-500 dark:border-slate-700 dark:text-slate-200"
                                >
                                    {{ t.provider }}
                                </td>
                                <td
                                    class="border-b border-slate-100 p-4 pl-8 text-slate-500 dark:border-slate-700 dark:text-slate-200"
                                >
                                    <span
                                        class="mr-2 rounded px-2.5 py-1.5 text-sm font-medium"
                                        :class="statusClass(t.status)"
                                    >
                                        {{ statusName(t.status) }}
                                    </span>
                                </td>
                                <td
                                    class="border-b border-slate-100 p-4 pl-8 text-slate-500 dark:border-slate-700 dark:text-slate-200"
                                >
                                    {{ t.created_at }}
                                </td>
                                <td
                                    class="border-b border-slate-100 p-4 pl-8 text-slate-500 dark:border-slate-700 dark:text-slate-200"
                                >
                                    <button
                                        class="text-indigo-500 hover:underline"
                                        @click.prevent="goToDetails(t)"
                                    >
                                        Detalhes
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="my-5 flex w-full">
                        <div class="mx-auto flex flex-col items-center">
                            <span class="mb-1 text-white">
                                Exibindo {{ pagination.from }} a
                                {{ pagination.to }} registros de
                                {{ pagination.total }}
                            </span>
                            <pagination
                                :pagination="pagination"
                                :offset="1"
                                @paginate="fetchPage"
                            ></pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Pagination from "../../../components/layouts/Pagination.vue";
import Filters from "../../../components/layouts/Filters.vue";
import { mapWritableState } from "pinia";
import { Store } from "../../../stores/store";

export default {
    components: { Pagination, Filters },
    data() {
        return {
            loading: false,
            filters: {},
            transfers: [],
            pagination: {
                total: 0,
                per_page: 0,
                from: 0,
                to: 0,
                current_page: 0,
            },
        };
    },
    computed: {
        ...mapWritableState(Store, ["user"]),
    },
    mounted() {
        this.fetch(true);
    },
    methods: {
        fetch(reset = false) {
            if (reset) {
                this.pagination.current_page = 1;
            }
            this.loading = true;
            const params = {
                ...this.filters,
                page: this.pagination.current_page,
            };
            axios
                .get("/api/financial/transfer", { params })
                .then(({ data }) => {
                    this.transfers = data.data;
                    this.pagination = { ...this.pagination, ...data };
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        fetchPage(page) {
            this.pagination.current_page = page;
            this.fetch();
        },
        manageUser(user) {
            if (!user) return;
            this.user = user;
            this.$router.push({
                name: "user.commissions",
                params: { user_id: user.id },
            });
        },
        goToDetails(t) {
            this.$router.push({
                name: "finnancial.transfer-details",
                params: { transfer_id: t.id },
            });
        },
        statusName(status) {
            switch (status) {
                case "pending_authorization":
                    return "Pendente de Autorização";
                case "pending_execution":
                    return "Pendente de Efetivação";
                case "authorized":
                    return "Autorizado";
                case "completed":
                    return "Concluído";
                case "rejected":
                    return "Rejeitado";
                case "pending_change":
                    return "Pendente de Alteração";
                case "rejected_on_file":
                    return "Rejeitado no Arquivo";
                default:
                    return status;
            }
        },
        statusClass(status) {
            return {
                "bg-yellow-500 text-white": [
                    "pending_authorization",
                    "pending_execution",
                    "pending_change",
                ].includes(status),
                "bg-green-500 text-white":
                    status === "completed" || status === "authorized",
                "bg-red-500 text-white":
                    status === "rejected" || status === "rejected_on_file",
            };
        },
    },
};
</script>
